// src/components/ScrollToTop.js
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // 1. LIVE SAVER: Continuously save Homepage scroll position while you are on it.
  useEffect(() => {
    const handleScroll = () => {
      if (pathname === "/" || pathname === "/home") {
        sessionStorage.setItem("homepageScroll", window.scrollY);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  // 2. RESTORATION & RESET: Handle the scroll jump when the page changes
  useLayoutEffect(() => {
    if (pathname === "/" || pathname === "/home") {
      // If we are back on Homepage, restore the saved position
      const savedPos = sessionStorage.getItem("homepageScroll");
      if (savedPos) {
        window.scrollTo({
          top: parseInt(savedPos, 10),
          behavior: "instant", // No animation, just teleport
        });
      }
    } else {
      // If we are on ANY other page (CollegeDetail, etc.), go to top immediately
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
